import PropTypes from 'prop-types';

export default function OutlineVideo(props) {
    const { color = 'currentColor', size = 20, strokeWidth = 1.5, ...rest } = props;

    return (
        <svg viewBox="0 0 20 20" fill="none" width={size} height={size} {...rest}>
            <path
                d="M19.167 5.833 13.333 10l5.834 4.167V5.833Z"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
            />
            <path
                d="M11.667 4.167H2.5c-.92 0-1.667.746-1.667 1.666v8.334c0 .92.747 1.666 1.667 1.666h9.167c.92 0 1.667-.746 1.667-1.666V5.833c0-.92-.747-1.666-1.667-1.666Z"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
            />
        </svg>
    );
}

OutlineVideo.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    strokeWidth: PropTypes.number,
};
